<template>
  <div
    class="delete-btns d-flex"
    style="gap: 0.25rem; height: 2rem"
  >
    <div
      v-if="!canDelete"
      class="gw_btn text-medium weight_500"
      style="--clr-back: var(--clr-error)"
      @click="canDelete = !canDelete"
    >
      <i class="mr-1 mdi mdi-trash-can-outline"> </i>
      {{ $t(`btn.delete_selected`) }}
    </div>
    <div
      class="gw_btn text-medium weight_500"
      @click="$emit('close')"
    >
      <i class="mr-1 mdi mdi-close"> </i>
      {{ $t('btn.cancel') }}
    </div>
    <div
      v-if="canDelete"
      class="gw_btn text-medium weight_500"
      style="--clr-back: var(--clr-error)"
      @click="$emit('confirm')"
    >
      <i class="mr-1 mdi mdi-trash-can-outline"> </i>
      {{ $t('btn.confirm_delete') }}
    </div>
    <slot> </slot>
  </div>
</template>

<script>
export default {
  name: 'TableDeleteBtns', 
 emits: ['close','confirm'],
  data() {
    return {
      canDelete: false,
    }
  },
}
</script>

<style>
.dltbtns {
}
</style>
